import Vue from 'vue'
import { v4 as uuidv4 } from 'uuid'

interface Data {
  isFocused: boolean;
}

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: false,
      default: undefined,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    labelVisibleAlways: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    step: {
      type: String,
      required: false,
      default: undefined,
    },
    name: {
      type: String,
      default: '',
      required: false,
    },
    placeholder: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: false,
      default: '',
    },
    metaError: {
      type: String,
      required: false,
      default: '',
    },
    optional: {
      type: Boolean,
      required: false,
      default: false,
    },
    extraClass: {
      type: String,
      required: false,
      default: '',
    },
    inputClass: {
      type: String,
      required: false,
      default: '',
    },
    preventPaste: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    pattern: {
      type: String,
      default: undefined,
    },
    inputmode: {
      type: String,
      default: undefined,
    },
    autocomplete: {
      type: String,
      default: undefined,
    },
  },

  data(): Data {
    return {
      isFocused: false,
    }
  },

  computed: {
    computedId() {
      return this.id || `input-${uuidv4()}`
    },
    isActive(): boolean {
      return this.isFocused
    },
    inputValue: {
      get() {
        return this.value
      },
      set(val: string) {
        this.$emit('input', val)
      },
    },
  },

  methods: {
    onFocus(): void {
      this.isFocused = true
      this.$emit('focus', true)
    },
    onChange(e: Event): void {
      this.$emit('change', e)
    },
    onBlur(): void {
      this.isFocused = false
      this.$emit('blur', true)
    },
    onPaste(e: Event): boolean {
      if (this.preventPaste) {
        e.preventDefault()
        return false
      }
      return true
    },
  },
})
